import $ from 'jquery';

import { sidebarImageInjectionLoader } from '~src/image';
import { addMagicFrameToCanvas } from '~core/magicFrame';
import { handleMagicFrameFrameSelection } from '~core/magicFrame';
import { getState } from '~src/state';

// TODO: this should never happen unless the image in the DB has missing width/height
function getMeta(url) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject();
    img.src = url;
  });
}

export const onAddMagicFrameToCanvas = async (event) => {
  event.preventDefault();

  const url = $(event.currentTarget).data('url');
  const svgClip = $(event.currentTarget).data('svg-clip');
  let width = $(event.currentTarget).data('width');
  let height = $(event.currentTarget).data('height');

  if (!width || !height || width === 'undefined' || height === 'undefined') {
    const img = await getMeta(url);
    width = img.width;
    height = img.height;
  }

  // TODO: check if width/height is bigger than the canvas itself

  if (getState('magicFrameSelectFramePhotoActive')) {
    await handleMagicFrameFrameSelection(url, width, height, svgClip);
    return;
  }

  $(event.currentTarget).append(sidebarImageInjectionLoader);

  await addMagicFrameToCanvas({ frameUrl: url, width, height, svgClip });

  $('.editor-sidebar-image-injection-loader').remove();
};
